// extracted by mini-css-extract-plugin
module.exports = {"content":"calltoaction_content__tzOXD","entrada":"calltoaction_entrada__O1FSf","boto":"calltoaction_boto__tIFvC","verifica":"calltoaction_verifica__XYIv8"};